// extracted by mini-css-extract-plugin
module.exports = {"visualitzacioSelector":"VisualitzacioSelectorFenofase_visualitzacioSelector__pDd-h"};